import { BuilderComponent } from "@builder.io/react";
import { BuilderContent, builder } from "@builder.io/sdk";
import { getBuilderAPIKey } from "@faire/web--source/builder/BuilderComponents/builderUtils";
import { registerBuilderComponents } from "@faire/web--source/builder/registerBuilderComponents/registerBuilderComponents";
import { registerBuilderDesignTokens } from "@faire/web--source/builder/registerBuilderDesignTokens/registerBuilderDesignTokens";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import React, { Suspense, use } from "react";

const BigVideoHeaderBannerBase: React.FC<{
  builderPromise: Promise<BuilderContent | undefined>;
  loadTimingRef?: React.RefCallback<HTMLElement>;
}> = ({ builderPromise, loadTimingRef }) => {
  const builderAPIKey = getBuilderAPIKey();
  if (builderAPIKey) {
    // have to initialize builder here again for preview to work
    builder.init(builderAPIKey);
    // register the components and design tokens
    // have to happen in the client component
    registerBuilderComponents();
    registerBuilderDesignTokens();
  }

  const builderContent = use(builderPromise);

  const trackViewRef = useDoActionWhenVisible(() =>
    trackLoggedOutRetailersLoggedOutHomeRedesignView(
      "big_video_header_banner",
      "VARIANT_2"
    )
  );
  const ref = useMergedRefs(loadTimingRef, trackViewRef);

  if (builderContent) {
    return (
      <div ref={ref}>
        <BuilderComponent
          content={builderContent}
          model="logged-out-homepage-video-header"
        />
      </div>
    );
  }

  return null;
};

export const BigVideoHeaderBanner: React.FC<{
  builderPromise: Promise<BuilderContent | undefined>;
  loadTimingRef?: React.RefCallback<HTMLElement>;
}> = (props) => {
  return (
    <Suspense
      fallback={
        <LoadingSkeleton
          aspectRatio={{ mobileAndAbove: "9/10", tabletAndAbove: "16/9" }}
          width="100%"
        />
      }
    >
      <BigVideoHeaderBannerBase {...props} />
    </Suspense>
  );
};
